import React from 'react';
import { Link } from 'react-router-dom';
import { personalInfo, navItems } from '../../data/mockData';
import { Twitter, Linkedin, Instagram, Mail, MapPin, ArrowUp, Heart } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-black overflow-hidden">
      {/* Ambient Glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/[0.04] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/[0.04] rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <Link 
              to="/" 
              className="text-2xl font-bold bg-gradient-to-r from-white via-neutral-300 to-neutral-400 bg-clip-text text-transparent"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Bivas Mishra
            </Link>
            <p className="mt-4 text-neutral-400 leading-relaxed max-w-md">
              Content Creator & Senior Business Analyst empowering narratives and driving business success through strategic insights.
            </p>
            {/* Social Links */}
            <div className="flex items-center space-x-3 mt-6">
              <a
                href={personalInfo.social.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white hover:text-black hover:border-transparent transition-all duration-300 hover:scale-110 hover:-rotate-6 hover:shadow-lg hover:shadow-white/20"
                aria-label="Twitter"
              >
                <Twitter size={18} className="text-white" />
              </a>
              <a
                href={personalInfo.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white hover:text-black hover:border-transparent transition-all duration-300 hover:scale-110 hover:rotate-6 hover:shadow-lg hover:shadow-white/20"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} className="text-white" />
              </a>
              <a
                href={personalInfo.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white hover:text-black hover:border-transparent transition-all duration-300 hover:scale-110 hover:-rotate-6 hover:shadow-lg hover:shadow-white/20"
                aria-label="Instagram"
              >
                <Instagram size={18} className="text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
            <nav className="flex flex-col space-y-3">
              {navItems.slice(0, 5).map((item) => (
                <Link
                  key={item.href}
                  to={item.href}
                  className="text-neutral-400 hover:text-white transition-all duration-300"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Get In Touch</h3>
            <div className="space-y-4">
              <a
                href="mailto:hi@iambivas.in"
                className="flex items-center text-neutral-400 hover:text-white transition-colors duration-300"
              >
                <Mail size={18} className="mr-3" />
                hi@iambivas.in
              </a>
              <div className="flex items-start text-neutral-400">
                <MapPin size={18} className="mr-3 mt-0.5 flex-shrink-0" />
                <span>India</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-neutral-500 text-sm flex items-center">
            Made with <Heart size={14} className="mx-1 text-white fill-white" /> © {new Date().getFullYear()} Bivas Mishra
          </p>
          <button
            onClick={scrollToTop}
            className="mt-4 sm:mt-0 p-3 bg-white rounded-xl hover:shadow-lg hover:shadow-white/20 transition-all duration-300 hover:-translate-y-1"
            aria-label="Scroll to top"
          >
            <ArrowUp size={20} className="text-black" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
